<template>
<div class="main-wrapper">
    <div>
     <b-table :items="items" :fields="fields" :busy="isLoading" responsive="sm" show-empty bordered striped head-variant="dark">
       <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(name)="row">
          <div>
            {{ row.item.name }} <br/>
            ({{ row.item.user_length ? row.item.user_length + " User" + pluralizeItems(row.item.user_length) : ''}}{{ row.item.locations_length ? ", " + row.item.locations_length + " Location" + pluralizeItems(row.item.locations_length) : ''}})
          </div>
      </template>
      <template #cell(type)="row">
          {{row.item.type}}
      </template>
      <template #cell(users)="row">
          <div v-for="user in row.item.users" v-if="user.firstName && user.lastName">
            {{user.firstName + ' ' + user.lastName}} ({{ user.email }})
          </div>
      </template>
     <template #cell(locations)="row">
        <div v-for="location in row.item.locations" v-if="location.hlLocationId">
            {{location.hlLocationId}}
        </div>
        <div v-for="location in row.item.deletedLocations" v-if="location.hlLocationId" style="color: #999;">
            {{location.hlLocationId}} (deleted)
        </div>
      </template>

    </b-table>
  </div>
</div>
</template>

<script>
import { ElizaService } from '@/services'
export default {
  data() {
    return {
      fields: [
          {key: '_id', label: 'Eliza Company Id'},
          {key: 'hlCompanyId', label:'HL Company ID'},
          {key: 'name', label: 'Eliza Company Name'},
          {key: 'type', label: 'Eliza Company Type'},
          {key: 'users', label: 'Users'},
          {key: 'locations', label: 'Locations'},
      ],
      items: [],
      isLoading: false
    }
  },
  async created() {
      try {
        this.isLoading = true;
        const res = await ElizaService.getElizaDetails()
        if(res && res.data && res.data.companies){
            this.items = res.data.companies;
            this.items.map(item => {
              item.user_length = item.users && item.users.length;
              item.locations_length = item.locations && item.locations.length;
              return item;
            })

        }
        this.isLoading = false
      } catch(error){
          console.error(error);
          alert(JSON.stringify(error));
      }
  },
  methods: {
    pluralizeItems(itemsLength) {
      return itemsLength === 1 ? '' : 's';
    }
  }
};
</script>

<style scoped>
 .main-wrapper {
     margin: 0 auto;
     width: 90%;
 }
 .main-wrapper .table-responsive-sm .table thead th {
     background: #333;
     color: #fff;
 }
</style>
